import {
  AdminSkill,
  ApiResponse,
  CreateSkillRequest,
  PaginationParams,
  UpdateSkillRequest,
} from "../../types/admin";
import httpClient from "../httpClient";
import { sanitizeArrayResponse } from "./helpers";

export const skillsApi = {
  getAll: async (params?: PaginationParams): Promise<ApiResponse<AdminSkill[]>> => {
    const response = await httpClient.get<AdminSkill[]>("/skills", params);
    return sanitizeArrayResponse(response);
  },

  getById: (id: string | number): Promise<ApiResponse<AdminSkill>> =>
    httpClient.get(`/skills/${id}`),

  create: (skill: CreateSkillRequest): Promise<ApiResponse<AdminSkill>> =>
    httpClient.post("/skills", skill),

  update: (id: string | number, skill: UpdateSkillRequest): Promise<ApiResponse<AdminSkill>> =>
    httpClient.put(`/skills/${id}`, skill),

  delete: (id: string | number): Promise<ApiResponse<void>> =>
    httpClient.delete(`/skills/${id}`),
};
